import type { User } from '@/models/User'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useAppStore = defineStore('app', () => {
  const baseUrl = '/'
  const user = ref<User | null>(null)
  const cachedUsername = ref('')
  const username = computed(() => user.value?.display_name ?? cachedUsername.value)

  return {
    baseUrl,
    user,
    cachedUsername,
    username
  }
})
